<div class="container-fluid pt-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
            <div class="row">
								<div class="col-sm-8">
                  <h3 class="pt-0 pb-4">Account Information</h3>
                  <div *ngIf="isContainApps" class="alert alert-success">&nbsp;
											{{ containAppsMessage }}
                  </div>
									<div *ngIf="saveSuccessful" class="alert alert-success">&nbsp;
											{{ sucessMessage }}
                  </div>
                  <div *ngIf="saveError" class="alert alert-danger">&nbsp;
											{{ errorMessage }}
									</div>
								</div>
								<div class="col-sm-4 text-sm-right" >
									 <a href="" class="btn btn-outline-secondary btn-sm py-2" routerLink="/userprofile" [queryParams]="{userId:currentUser?.id, organizationId:currentUser?.userSessionEntity?.organizationId}">User Profile</a>
								</div>
						</div>

          <form [formGroup]="accountInfoForm">
						<div class="form-row">
							<div class="form-group col-md-4">
								<label for="phone">Phone</label>
								<input type="text" id="phone" formControlName="phone" readonly class="w-100">
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-md-4">
								<label for="email">Email</label>
								<input type="text" id="email" formControlName="email" readonly class="w-100">
							</div>
						</div>

						<h5>Change Password</h5>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="confirm_password">Current Password</label>
                <input type="password" id="current_password" formControlName="currentPassword" class="w-100">
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="new_password">New Password</label>
                <input type="password" id="new_password" formControlName="newPassword" class="w-100" (change)="updateConfirmPwd();">
								<span class="help-text text-muted">Password must be at least 12 characters, a lowercase letter, an uppercase letter, a number, a symbol, no parts of your username, does not include your first name, does not include your last name. Your password cannot be any of your last 24 passwords.</span>
              </div>
						</div>
						<div class="form-row" *ngIf="this.accountInfoForm.get('newPassword').value !== ''">
              <div class="form-group col-md-4">
                <label for="confirm_password">Confirm New Password</label>
                <input type="password" id="confirm_password" formControlName="confirmPassword" class="w-100">
                <div class="text-danger" *ngIf="(this.accountInfoForm.get('newPassword').value !== '') && (this.accountInfoForm.get('confirmPassword').hasError('same'))">
                    <span class="fa fa-warning"></span> Password mismatch
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary w-auto mt-4" [disabled]="(this.accountInfoForm.get('newPassword').value == '') || (this.accountInfoForm.get('confirmPassword').hasError('same'))" (click)="updatePassword();">Change Password</button>
            <h5>Forgot Password Question</h5>
						<div class="form-row">
              <div class="form-group col-md-4">
                <span class="help-text text-muted">Select a forgotten password question so you can reset your password in case you have trouble signing in to your GSA account.</span>
                <label for="security_question">Security Question</label>
                <select id="security_question" formControlName="securityQuestion" class="w-100" (change)="changeQuestion();">
									<option value ='null' selected disabled>Choose...</option>
                  <option value ='What is the food you least liked as a child?'>What is the food you least liked as a child?</option>
                  <option value ='What is the name of your first stuffed animal?'>What is the name of your first stuffed animal?</option>
                  <option value ='What did you earn your first meadal or award for?'>What did you earn your first meadal or award for?</option>
                  <option value ='What is your favorite security question?'>What is your favorite security question?</option>
                  <option value ='What is the toy/stuffed animal you liked the most as a kid?'>What is the toy/stuffed animal you liked the most as a kid?</option>
                  <option value ='What was the first computer game you played?'>What was the first computer game you played?</option>
                  <option value ='What is your favorite movie quote?'>What is your favorite movie quote?</option>
                  <option value ='What was the mascot of the first sports team you played on?'>What was the mascot of the first sports team you played on?</option>
                  <option value ='What music album or song did you first purchase?'>What music album or song did you first purchase?</option>
                  <option value ='What is your favorite piece of art?'>What is your favorite piece of art?</option>
								</select>
              </div>
						</div>
						<div class="form-row" *ngIf="this.showAnswer">
              <div class="form-group col-md-4">
                <label for="security_answer">Answer</label>
                <input type="password" id="security_answer" formControlName="securityAnswer" class="w-100">
              </div>
            </div>
            <button type="button" class="btn btn-primary w-auto mt-4" [disabled]="(!this.showAnswer) || (this.showAnswer && (this.accountInfoForm.get('securityAnswer').value === null) || (this.accountInfoForm.get('securityAnswer').value === ''))"  (click)="updateSecurityQn();" >Update</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
